import React from 'react'
import styled from '@emotion/styled'
import { bool, string } from 'prop-types'

import { Link } from '@jelly/ui'
import { makeImgResizerUrl } from '@jelly/utils'

// Styled Components via Emotion
const CardContainer = styled.div`
	border-bottom: 1px solid ${({ theme }) => theme.colors.grey01};
	display: block;
	height: 100%;
	width: 100%;
`
const Header1 = styled.div`
	color: ${({ isArticleContentType, theme }) =>
		isArticleContentType ? theme.relatedRail.textColor : theme.relatedRail.linkColor};
	font-size: 14px;
	line-height: 20px;
	transition: all 0.4s ease;
	vertical-align: middle;
`
const CardContent = styled(Link)`
	cursor: pointer;
	display: flex;
	padding: 10px 15px;
	transition: all 0.4s ease;

	div {
		padding-left: 10px;
	}

	&:hover {
		background: ${({ theme }) => theme.relatedRail.backgroundHoverColor};
		color: ${({ isArticleContentType, theme }) =>
			isArticleContentType ? theme.relatedRail.linkHoverColor : 'inherit'};

		${Header1} {
			color: ${({ theme }) => theme.relatedRail.linkHoverColor};
		}
	}
`
const FlexWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`
const ImgThumbnail = styled.img`
	align-self: center;
	border-radius: ${({ isProfile }) => (isProfile ? '50%' : '')};
	box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.3);
	height: 65px;
	justify-content: center;
	max-width: 65px;
	object-fit: cover;
	width: auto;
`
const Header2 = styled.div`
	color: ${({ theme }) => theme.colors.gray[500]};
	font-size: 10px;
	line-height: 17px;
`
const Sub = styled.div`
	color: ${({ theme }) => theme.relatedRail.textColor};
	font-size: 14px;
	line-height: 17px;
`
const SponsoredBadge = styled.div`
	color: ${({ theme }) => theme.colors.gray[500]};
	font-size: 12px;
	padding-bottom: 8px;
`

RelatedCard.propTypes = {
	contentType: string,
	header1: string,
	header2: string,
	link: string,
	isProfile: bool,
	sub: string,
	thumbnail: string,
}

export function RelatedCard(props) {
	const { contentType, header1, header2, link, isProfile, sub, thumbnail, sponsored } = props
	const isArticleContentType = contentType === 'Articles'

	return (
		<CardContainer>
			<CardContent href={link}>
				<ImgThumbnail
					alt={header1}
					className="lazyload"
					isProfile={isProfile}
					data-src={makeImgResizerUrl({ src: thumbnail, method: 'rc', w: 65, h: 65 })}
				/>
				<FlexWrapper>
					{sponsored && <SponsoredBadge>Sponsored Content</SponsoredBadge>}
					{sub && <Sub>{sub}</Sub>}
					<Header1 isArticleContentType={isArticleContentType}>{header1}</Header1>
					<Header2>{header2}</Header2>
				</FlexWrapper>
			</CardContent>
		</CardContainer>
	)
}
